<template>
	<!-- A unified status selector for conversations and projects. -->
	<BaseSelect
		v-bind="$attrs"
		:disabled="disabled"
		:items="items"
		item-title="label"
		item-value="value"
		:label="label"
		class="status-input"
		hide-details
		variant="outlined">
		<template #item="{ props, item }">
			<v-list-item v-bind="props">
				<template #prepend>
					<v-icon v-if="item.raw.icon" size="small" :class="`status-icon status-${item.raw.value.toLowerCase()}`" class="mr-2">
						{{ item.raw.icon }}
					</v-icon>
				</template>
			</v-list-item>
		</template>
		<template #selection="{ item }">
			<v-icon v-if="item.raw.icon" size="small" :class="`status-icon status-${item.raw.value.toLowerCase()}`" class="mr-2">
				{{ item.raw.icon }}
			</v-icon>
			<span>{{ item.raw.label }}</span>
		</template>
	</BaseSelect>
	<!-- NOTE: We intentionally forward v-model via $attrs to keep Vue 2 compatibility. -->
</template>

<script setup lang="ts">
	import BaseSelect from "@/components/formfields/BaseSelect.vue";
	import constants from "@/api/constants";
	import { computed } from "vue";
	import type { EntityType } from "@/types/EntityType";
	import { getStatusIcon } from "@/helpers/statusIcon";

	const props = withDefaults(
		defineProps<{
			entityType: EntityType;
			disabled?: boolean;
			label?: string;
		}>(),
		{ label: "Status" }
	);

	const items = computed(() => {
		if (props.entityType === "project") {
			return [
				{
					label: "Not Started",
					value: constants.PROJECT_STATUS.NotStarted,
					icon: getStatusIcon(constants.PROJECT_STATUS.NotStarted)
				},
				{
					label: "In Progress",
					value: constants.PROJECT_STATUS.InProgress,
					icon: getStatusIcon(constants.PROJECT_STATUS.InProgress)
				},
				{
					label: "Completed",
					value: constants.PROJECT_STATUS.Completed,
					icon: getStatusIcon(constants.PROJECT_STATUS.Completed)
				}
			];
		}
		// conversation
		return [
			{
				label: "Ready For Review",
				value: constants.CONVERSATION_STATUS.ReadyForReview,
				icon: getStatusIcon(constants.CONVERSATION_STATUS.ReadyForReview)
			},
			{
				label: "Reviewed",
				value: constants.CONVERSATION_STATUS.Reviewed,
				icon: getStatusIcon(constants.CONVERSATION_STATUS.Reviewed)
			}
		];
	});
</script>

<style scoped>
	.status-input:deep(.v-field__input>input) {
		caret-color: transparent !important;
	}
</style>
